import React from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    '& *': {
      margin: 'revert',
      padding: 'revert-layer',
      maxWidth: '100%',
    },
    // Headings
    '& h1': {
      fontSize: '2rem',
      fontWeight: 'bold',
      margin: '24px 0 16px',
    },
    '& h2': {
      fontSize: '1.8rem',
      fontWeight: 'bold',
      margin: '20px 0 14px',
    },
    '& h3': {
      fontSize: '1.6rem',
      fontWeight: '600',
      margin: '18px 0 12px',
    },
    '& h4': {
      fontSize: '1.4rem',
      fontWeight: '600',
      margin: '18px 0 12px',
    },
    '& p': {
      fontSize: '1rem',
      lineHeight: '1.6',
      marginBottom: '16px',
    },
    '& ul': {
      listStyleType: 'disc',
      paddingLeft: '32px',
      marginBottom: '16px',
    },
    '& li': {
      fontSize: '0.9rem',
      marginBottom: '8px',
    },
    '& ul ul': {
      listStyleType: 'circle',
    },
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      margin: '16px 0',
    },
    '& th, & td': {
      padding: '12px',
      border: '1px solid #ddd',
      textAlign: 'left',
    },
    '& th': {
      fontWeight: 'bold',
    },
  },
}));

const MarkdownHTMLEmbed = ({ markdown }) => {
  const classes = useStyles();

  // Convert markdown to HTML using marked
  const rawHtml = marked.parse(markdown);

  // Sanitize the generated HTML using DOMPurify
  const safeHtml = DOMPurify.sanitize(rawHtml);

  return <div className={classes.root} dangerouslySetInnerHTML={{ __html: safeHtml }} />;
};

export default MarkdownHTMLEmbed;
